__webpack_require__.p = "/magazin/juegos/";